var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgColoredDot = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    transform: "translate(-1610.94 -465.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    transform: "translate(1610.94 465.94)",
    fill: "#fff",
    stroke: "#016ece",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(1613.94 468.94)",
    fill: "#016ece"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgColoredDot, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/colored-dot.9975af27.svg";
export { ForwardRef as ReactComponent };